module.exports = __webpack_public_path__ + "static/img/img6.70c20d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img6.jpg
// module id = gLs/
// module chunks = 0